export interface InputAriaHookProps {
    invalid?: boolean;
    hasPlaceholder?: boolean;
    hasDescription?: boolean;
    descriptionId: string;
    labelId: string;
}

interface AriaProps {
    'aria-labelledby'?: string;
    'aria-describedby'?: string;
    'aria-invalid'?: boolean;
}

export const useInputAriaProps = ({
    invalid,
    hasPlaceholder,
    hasDescription,
    descriptionId,
    labelId,
}: InputAriaHookProps): AriaProps => {
    const ariaProps: AriaProps = {};
    invalid && (ariaProps['aria-invalid'] = !!invalid);
    if (hasPlaceholder) {
        ariaProps['aria-labelledby'] = `input-label-${labelId}`;
    }
    if (hasDescription) {
        ariaProps['aria-describedby'] = `input-description-${descriptionId}`;
    }
    return ariaProps;
};
